import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, message } from 'antd';
import { FormItem, Button } from 'ui-kit';
import { Input } from 'components/Form';
import { checkPassword } from 'utils/form';
import { changePassword } from 'api/owners';
import { YOU_DO_NOT_HAVE_PERMISSION_TO_THIS_ACTION_ERROR } from 'consts';

export default function ChangePasswordForm({ initialValues, onSubmit, hasSetPassword = false }) {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const handleSumbit = (values) => {
    setSaving(true);
    changePassword(values)
      .then((res) => {
        setSaving(false);
        form.resetFields();
        if (res.ok) {
          message.success('Password changed');
          onSubmit();
        } else {
          // Error if the user is cohost
          if (
            Object.values(res?.errors?.fields)?.[0] ===
            YOU_DO_NOT_HAVE_PERMISSION_TO_THIS_ACTION_ERROR
          ) {
            message.error(YOU_DO_NOT_HAVE_PERMISSION_TO_THIS_ACTION_ERROR);
            return;
          }

          message.error(res.data || 'Error updating password');
        }
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e);
      });
  };

  return (
    <Form
      form={form}
      name="settings-password"
      layout="vertical"
      initialValues={initialValues}
      onFinish={handleSumbit}
    >
      {hasSetPassword && (
        <FormItem
          name="old-password"
          label="Current Password"
          rules={[
            {
              required: hasSetPassword,
              message: 'Please input your password!',
            },
          ]}
        >
          <Input.Password placeholder="Current Password..." />
        </FormItem>
      )}
      <FormItem
        name="password"
        label="New Password"
        rules={[
          {
            required: true,
            message: 'Please input new password!',
          },
        ]}
        hasFeedback
      >
        <Input.Password placeholder="New Password..." />
      </FormItem>
      <FormItem
        name="confirmPassword"
        label="Confirm New Password"
        dependencies={['password']}
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Please confirm your password!',
          },
          checkPassword,
        ]}
      >
        <Input.Password placeholder="Confirm New Password..." />
      </FormItem>
      <div className="hc-settings__button-row">
        <FormItem noStyle shouldUpdate>
          {({ getFieldsError, getFieldsValue }) => {
            const isFormValid = getFieldsError().every(({ errors }) => !errors.length);
            const allHasValues = Object.values(getFieldsValue()).every(Boolean);
            return (
              <Button
                variant="contained"
                type="submit"
                disabled={!allHasValues || !isFormValid}
                fullWidth
                loading={saving}
              >
                Update password
              </Button>
            );
          }}
        </FormItem>
      </div>
    </Form>
  );
}

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func,
  hasSetPassword: PropTypes.bool,
  initialValues: PropTypes.objectOf(
    PropTypes.shape({
      currentPassword: '',
      password: '',
      newPassword: '',
    }),
  ),
};

ChangePasswordForm.defaultProps = {
  onSubmit: () => null,
  initialValues: {
    currentPassword: '',
    password: '',
    newPassword: '',
  },
};
